import { render } from "./TruncatedText.vue?vue&type=template&id=36c81256&scoped=true"
import script from "./TruncatedText.vue?vue&type=script&lang=js"
export * from "./TruncatedText.vue?vue&type=script&lang=js"

import "./TruncatedText.vue?vue&type=style&index=0&id=36c81256&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c81256"]])

export default __exports__